import { HTTPStatusCodes } from 'constants/httpStatusCodes';
import API from 'services/API';
import strings from 'strings';
import { Endpoints } from 'UI/constants/endpoints';
import { getErrorMessage } from 'UI/utils';

const SUBMIT_MESSAGES = strings.sendoutsV2.alerts.submitMessages;

const ACTION_BY_SEVERITY = {
  success: SUBMIT_MESSAGES.actions.updated,
  error: SUBMIT_MESSAGES.actions.updating
};

const buildEntityStatusAlert = ({ severity, processType, body }) => ({
  severity,
  title: strings.formatString(SUBMIT_MESSAGES[severity].title, {
    processType,
    action: ACTION_BY_SEVERITY[severity]
  }),
  autoHideDuration: 5000,
  ...(body ? { body } : {})
});

export const updateEntityStatus = async ({ id, payload, processType }) => {
  try {
    const endpoint = `${Endpoints.Sendouts}/${id}`;
    const response = await API.patch(endpoint, payload);

    if (response.status !== HTTPStatusCodes.Ok) {
      return {
        success: false,
        response,
        alert: buildEntityStatusAlert({
          severity: 'error',
          processType,
          body: strings.formatString(SUBMIT_MESSAGES.unexpectedStatus, { status: response.status })
        })
      };
    }

    return {
      success: true,
      response,
      alert: buildEntityStatusAlert({ severity: 'success', processType })
    };
  } catch (error) {
    return {
      success: false,
      error,
      alert: buildEntityStatusAlert({
        severity: 'error',
        processType,
        body: getErrorMessage(error, error?.message ?? 'Something went wrong')
      })
    };
  }
};
